import script from "./ReceiptModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ReceiptModal.vue?vue&type=script&setup=true&lang=js"

import "./ReceiptModal.vue?vue&type=style&index=0&id=1e9ee220&scoped=true&lang=css"

import exportComponent from "/Users/amsrafid/Projects/www/miaccounts-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1e9ee220"]])

export default __exports__